<main>
    <div class="container dark-grey-text mt-5">
        <div class="row wow fadeIn">
            <div class="col-md-3 mb-4">
                <img class="img-fluid img-thumbnail" src="img/zetdc.png"
                    alt="Zesa" />
            </div>
            <div class="col-md-9 mb-4">
                <h2>Buying Zesa</h2>
                <p>Your Token will be emailed to you</p>
                <div class="p-1">
                    <form id="form" action="post">
                        <div class="row">
                            <div class="form-group  col-md-6">
                                <p class="font-weight-bold">Receiver Number</p>

                                <vue-phone-number-input id="Umbai"
                                    v-model="receiverNumber"
                                    default-country-code="ZW"
                                    no-example required size="lg" maxlength="12"
                                    @update="ValidateReceiverNumber" />
                                <div><span class="text-warning">{{valideReceiverNumberMessage}}</span></div>
                            </div>
                            <div class="form-group col-md-6">
                                <p class="font-weight-bold">Sender Number</p>
                                <vue-phone-number-input id="Umbai"
                                    v-model="senderNumber"
                                    default-country-code="ZA"
                                    required size="lg" no-example maxlength="12"
                                    @update="ValidateSenderNumber" />
                                <div><span class="text-warning">{{valideSenderNumberMessage}}</span></div>
                            </div>
                        </div>
                        <div class="form-group">
                            <p class="font-weight-bold">Meter Number</p>
                            <input v-model="zesaModel.meterNumber" type="text"
                                class="form-control form-control"
                                required placeholder="Meter Number *">
                        </div>
                        <div class="form-group">
                            <input v-model="zesaModel.currency" hidden
                                placeholder="currency" />
                            <p class="font-weight-bold">Amount</p>
                            <select v-model="selectedProduct" required
                                class="form-control">
                                <option
                                    v-for="(value, name, index) in priceList.productList"
                                    :value="value"
                                    :key="name">

                                    <span v-if="value.description">
                                        {{value.description}}
                                    </span>

                                    <span
                                        v-else-if="product.displaySalesCurrency">
                                        {{product.isoSalesCurrency}}{{
                                        value.salesCurrencyAmount }} (
                                        {{product.isoCurrency}}{{
                                        value.totalAmount }})
                                    </span>

                                    <span v-else>
                                        {{product.isoCurrency}}{{
                                        value.totalAmount }}
                                    </span>

                                </option>
                            </select>
                        </div>
                        <br />
                        <base-button class="btn-3" @click="proceedToPayment"
                            type="primary" icon="ni ni-credit-card">
                            Proceed to payment</base-button>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!--spinner-->
    <div class="vld-parent">
        <loading :active.sync="isLoading" :can-cancel="false"
            :is-full-page="fullPage"></loading>
    </div>
    <!--spinner-->
    <!--Model-->
    <div>
        <modal :show.sync="showNotification" gradient="danger"
            modal-classes="modal-danger modal-dialog-centered">
            <div class="py-3 text-center">
                <i class="ni ni-bell-55 ni-3x"></i>
                <h4 class="heading mt-4">Error</h4>
                <p>{{notificationMessage}}</p>
            </div>

            <template slot="footer">
                <base-button type="white" @click="showNotification = false">
                    Close
                </base-button>
            </template>
        </modal>
    </div>
    <!--model-->
</main>